import { css as n, styled as t } from "styled-components";
import { skeletonFadeAnimation as x } from "../../../styles/animation.js";
import { VoteKind as m } from "../../../types/Deal/index.js";
import { Icon as s } from "../../../components/Icon/index.js";
import { BodyHeavy as b } from "../../../styles/typography/index.js";
import { Colors as i, rgbToHex as e } from "../../../styles/colors/index.js";
import { Theme as r } from "../../../styles/themes/index.js";
var h = /* @__PURE__ */ ((o) => (o[o.COLD = 0] = "COLD", o[o.NORMAL = 1] = "NORMAL", o[o.HOT = 2] = "HOT", o[o.VERY_HOT = 3] = "VERY_HOT", o))(h || {});
const a = n`
  color: rgb(${i.Blue});
`, f = n`
  color: rgb(${r.colors.Alpha});
`, l = n`
  color: rgb(${r.colors.Brand});
`, y = n`
  color: rgb(${r.colors.Brand});
`, u = {
  0: a,
  1: f,
  2: l,
  3: y
}, c = t.span`
  ${b}
  display: flex;
  align-items: center;
  ${({ level: o }) => u[o]}
`, g = n`
  font-size: 18px;
  border-radius: 12px;
  display: flex;
  background: transparent;
  color: ${r.colors.Alpha};
  transition: all 0.5s ease;
  overflow: hidden;
`, B = "--disable-hover-ice", R = t.button`
  ${g}
  margin-right: 4px;

  &:hover {
    background-color: var(${B}, rgb(${r.colors.Tango}));
  }
`, d = "--disable-hover-hot", _ = t.button`
  ${g}
  margin-left: 4px;

  &:hover {
    color: var(${d}, rgb(${r.colors.Brand}));
    background-color: var(${d}, rgb(${r.colors.Uniform}));
  }
`, z = t(s)`
  font-size: 24px;

  &:hover {
    color: rgb(${r.colors.Brand});
  }
`, D = t(s)`
  font-size: 24px;

  &:hover {
    color: rgb(${i.Blue});
  }
`, S = n`
  ${c} {
    color: rgb(${i.Gray});
  }
`, $ = n`
  padding: 8px 11px 8px 12px;
  border-radius: 24px;
  border: 1px solid rgb(${r.colors.Golf});
  align-items: center;
`, V = n`
  @keyframes glowing {
    0% {
      box-shadow: 0 0 -10px ${e(r.colors.Brand)};
    }
    40% {
      box-shadow: 0 0 20px ${e(r.colors.Brand)};
    }
    60% {
      box-shadow: 0 0 20px ${e(r.colors.Brand)};
    }
    100% {
      box-shadow: 0 0 -10px ${e(r.colors.Brand)};
    }
  }

  animation: glowing 1500ms infinite;
`, N = t.div`
  min-width: 98px;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${$}
  ${({ inactive: o }) => o && S}

  ${({ hasAnimation: o }) => o && V}
`, p = t(s)`
  font-size: 24px;
  border-radius: 12px;
  display: flex;
  background-color: rgb(${r.colors.Hotel});
  color: rgb(${r.colors.Alpha});
  margin-right: 8px;
  margin-left: 4px;
`, v = t(s)`
  font-size: 24px;
  margin-right: 8px;
`, w = n`
  ${a};
  ${c} {
    ${a};
  }
`, H = n`
  ${l};
  ${c} {
    ${l};
  }
`, F = t.button`
  ${$}
  background-color: transparent;
  display: flex;
  align-items: center;

  ${({ kind: o }) => o === m.INCREASE ? H : w}
  ${p} {
    display: none;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      ${v} {
        display: none;
      }

      ${p} {
        display: flex;
      }
    }
  }
`, G = t.div`
  width: 98px;
  height: 32px;
  border-radius: 24px;
  margin-bottom: 4px;
  ${x}
`, M = t.div`
  width: 58px;
  height: 32px;
  border-radius: 24px;
  margin: 0 12px 4px 12px;
  ${x}
`;
export {
  d as DISABLE_HOVER_HOT,
  B as DISABLE_HOVER_ICE,
  M as DealCommentButtonSkeleton,
  h as DealTemperatureLevel,
  N as DealVoteButtonContainer,
  G as DealVoteButtonSkeleton,
  R as DealVoteColdDown,
  c as DealVoteTemperature,
  _ as DealVoteWarmUp,
  F as DealVotedContainer,
  z as FlameIcon,
  p as RemoveVoteIcon,
  D as SnowIcon,
  v as VotedIcon
};
